import { BDO, PriceType } from './loose-order';
import { OrderType } from './order-type';
import { PaymentType } from './payment';

export interface FinancesOrderView {
	id: number;
	type: OrderType;
	client: {
		id: number;
		name: string;
		email: string;
		nip: string;
	};
	address: string;
	bdo: BDO;
	wasteType: string;
	netPrice: number;
	grossPrice: number;
	priceType: PriceType;
	paid: number;
	invoice: string | null;
	wantedPaymentType: PaymentType;
	onPlace: boolean;
	deliveryDate: string;
	claimingDate: string | null;
	relatedId: number | null;
	wasReplacement: boolean;
}
